var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('DaySelector',{on:{"select":_vm.load}}),_c('DailySummary',{staticClass:"my-5",attrs:{"groups":_vm.groups,"loading":_vm.loading,"biz":_vm.biz}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }